import React, { Dispatch } from 'react'
import { ThemeTypes } from '../../context/ContextTypes'
import { useTheme } from '../../context/ThemeContext'
import { themeModes } from '../settingsComp/ThemeSettings'
import { useUserData } from '../../context/UserDataContext'

type ThemeSelectMenuPropsType = {
    setMenuStatus: Dispatch<React.SetStateAction<boolean>>
}

const ThemeSelectMenu = (props: ThemeSelectMenuPropsType) => {

    const BASE_URL = process.env.REACT_APP_BASE_URL
    // Theme context
    const {theme, setTheme} = useTheme()

    const { username } = useUserData()

    // Handle click theme button
    /* const handleThemeButtonClick = (name: string) => {
        setTheme(name as ThemeTypes)
        props.setMenuStatus(false)
    } */

        // Handle click theme button
    const handleThemeButtonClick = async (name: string) => {
        setTheme(name as ThemeTypes)
        props.setMenuStatus(false)
        //const userData = sessionStorage.getItem("user");
    // if (userData) {
    //     try {
    //         const parsedUser = JSON.parse(userData);
    //         const username = parsedUser.preferred_username;
    //         const token = localStorage.getItem("access_token");
            
    //         const response = await fetch(`${BASE_URL}/identity_manager/api/v1/updateuserthememode`,
    //             {
    //                 method: "PUT",
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                     "Content-Type": "application/json",
    //                 },
    //                 body: JSON.stringify({
    //                     username: username,
    //                     thememodebconex: name.toString()
    //                 }),
    //             }
    //         );
            
    //         // You might want to handle the response here
    //         if (!response.ok) {
    //             throw new Error('Network response was not ok');
    //         }
    //         const responseData = await response.json();
    //         console.log(responseData);
            
    //     } catch (error) {
    //         console.error("Error:", error);
    //     }
    // }

        try 
        {
            const token = localStorage.getItem("access_token");
            
            const response = await fetch(`${BASE_URL}/identity_manager/api/v1/updateuserthememode`,
                {
                    method: "PUT",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        username: username,
                        thememodebconex: name.toString()
                    }),
                }
            );
            
            // You might want to handle the response here
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const responseData = await response.json();
            console.log(responseData);
            
        } catch (error) {
            console.error("Error:", error);
        }
    }

    return (
        <div className={`theme-select-menu`}>
            {themeModes.map((themes, index) => (
                <div key={index} className={`theme-icon-wrapper`} style={{backgroundColor: theme === themes.name ? 'var(--color-accent-bg)' : ''}} onClick={() => handleThemeButtonClick(themes.name)}>
                    <div>
                        {React.cloneElement(themes.icon, {color: theme === themes.name ? 'var(--color-main-white)' : 'var(--color-text)'})}
                    </div>
                    <span style={{color: theme === themes.name ? 'var(--color-main-white)' : ''}}>{themes.name}</span>
                </div>
            ))}
        </div>
    )
}

export default ThemeSelectMenu